/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LevelEngagement } from './levelEngagement';

export type StudentEngagementRecordLevelProgress = { [key: string]: LevelEngagement };
